export default "__VITE_ASSET__zG1$B8$S__"